<template>
  <div>
      <el-row class="cnt-wrapper">
          <el-col :span="6">
              <div class="dept-side">
                    <el-row class="dept-side-hd">
                        <el-col :span="12">渠道用户组</el-col>
                    </el-row>
                    <el-table ref="sourceTable" highlight-current-row v-loading="loading" :data="list" style="width: 100%" @row-click="showView" height="700">
                        <el-table-column prop="name"></el-table-column>
                        <el-table-column width="40">
                            <template slot-scope="scope">
                                <i class="el-icon-delete" @click="handleDelete(scope.row)"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-row class="searchSection">
                        <el-col :span="4" :offset="10">
                            <el-button type="text" size="medium" @click="handleCreate">+新增</el-button>
                        </el-col>
                    </el-row>
              </div> 
          </el-col>
          <el-col :span="18">
              <div class="staff-main-content" style="border:1px solid #dcdcdc" v-loading="loading">
                  <el-row class="staff-main-title clearfix">
                        <el-col :span="22">绑定渠道{{form.id > 0 ? '-编辑' : '-新增'}}</el-col>
                        <el-col :span="2">
                            <el-button type="text" size="medium" @click="resetForm">刷新</el-button>
                        </el-col>
                  </el-row>
                  <br><br>
                  <el-row class="staff-main-item">
                        <el-form ref="form" :model="form" :rules="rules">
                            <el-form-item prop="name" label="用户组名称">
                                <el-input v-model="form.name" style="width:80%"></el-input>
                            </el-form-item>
                            <el-form-item prop="uids" label="用户组成员">
                                <el-select v-model="form.uids" filterable multiple placeholder="请选择" style="width:80%" :key="form.id">
                                    <el-option
                                            v-for="item in users"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                  </el-row>
                  <el-row class="staff-main-item">
                        <p>
                            <ChannelTree :checked_ids="form.channel_ids" @change="channelTreeChange"></ChannelTree>
                        </p>
                        <el-alert
                            title="温馨提示"
                            type="info"
                            description="线索分配顺序：绑定渠道>个人绑定区域>用户组绑定渠道">
                        </el-alert>
                        <el-table
                        :loading="loading"
                        :data="channels"
                        border
                        max-height="350">
                            <el-table-column label="所属一级渠道" width="180">
                                <template slot-scope="scope">
                                    {{scope.row.channel_name}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="address" label="绑定二级渠道">
                                <template slot-scope="scope" >
                                    <a>
                                        <el-tag
                                            class="channelTag"
                                            v-for="channel in scope.row.channels"
                                            :key="channel.channel_id"
                                            closable
                                            @close="unbindChannel(channel.channel_id)"
                                        >
                                            <i v-if="channel.is_lock == 1" class="el-icon-fa-lock"></i> {{channel.channel_name}}
                                        </el-tag>
                                    </a>
                                </template>
                            </el-table-column>
                        </el-table>
                  </el-row>
                  <el-row class="staff-main-btn">
                        <el-col :span="4" :offset="10">
                            <el-button type="primary" size="medium" @click="handleSave" :loading="submiting">保存</el-button>
                        </el-col>
                  </el-row>
              </div>
          </el-col>
      </el-row>
  </div>
</template>
<style scoped>
</style>
<script>
  import UserService from "~/services/user";
  import SourceGroupService from "~/services/SourceGroup";
  import ChannelTree from "~/views/user/dialog/channelTree.vue";
  export default {
      name: "sourceGroup",
      components: {
        ChannelTree,
      },
      data() {
          return {
              form: {
                  id: '',
                  name: '',
                  channels: [],
                  channel_ids: [],
                  uids: [],
              },
              rules: {
                  name: [
                      {
                          required: true,
                          message: "请输入用户组名称",
                          trigger: 'blur'
                      },
                      {
                          type: "string",
                          max: 30,
                          message: "长度不能超过30个字符",
                          trigger: 'blur'
                      }
                  ],
                  uids: [
                      {
                          required: true,
                          message: "请选择成员",
                          trigger: 'blur'
                      }
                  ]
              },
              loading: false, 
              list: [],
              users: [],
              searcheModel: {},
              dialogFormVisible: false,
              submiting: false,
          }
      },
      created: function () {
          this.resetForm();
          this.getSelectOptions();
      },
      
      computed: {
        channels() {
            if (!this.form.channels || this.form.channels.length === 0) {
                return [];
            }
            return this.form.channels.reduce((acc, current) => {
                const existing = acc.find(item => item.id == current.pid);
                if (existing) {
                    existing.channels.push(current);
                } else if(current.pid == 0){
                    const p_existing = acc.find(item => item.id == current.channel_id);
                    if(!p_existing){
                        acc.push({
                            pid: 0,
                            id: current.channel_id,
                            channel_name: current.channel_name,
                            channels: [],
                        });
                    }
                }else {
                    acc.push({
                        pid: 0,
                        id: current.pid,
                        channel_name: current.parent_name,
                        channels: [current],
                    });
                }
                // console.log(acc);
                return acc;
            }, []).sort((a, b) => a.id - b.id);
          }
      },
      watch: {
         
      },
      methods: {
          resetForm() {
              this.list = [];
              this.form = {};
              this.searcheModel = {};
              this.getList(this.searcheModel);
          },

          handleCreate() {
              this.form = {
                  id: '',
                  name: '',
                  channels: [],
                  channel_ids: [],
                  uids: [],
              };
              // 取消选择当前行
              this.$refs.sourceTable.setCurrentRow(null);
          },

          getList(params) {
              this.loading = true;
              SourceGroupService.getList(params).then((res) => {
                  if (res.code == 0) {
                      this.list = res.data;
                  }
                  this.loading = false;
              })
              .catch((err) => {
                  console.error(err);
                  this.loading = false;
              });

          },

          getSelectOptions() {
              UserService.getAll({
                  fields: "id,name",
                  scenario: "all-user"
              }).then(res => {
                  if (res.code == 0) {
                      this.users = res.data
                  }
              })
          },

          showView(row){
              this.$refs.sourceTable.setCurrentRow(row);
              this.form = row;
              const updatedUidsArray = this.form.users.map(item => item.user_id);
              this.$set(this.form, 'uids', updatedUidsArray);
              this.form.channel_ids = this.form.channels.map(item => item.channel_id);
          },

          channelTreeChange(val){
              this.$set(this.form, 'channels', val);
              this.form.channel_ids = this.form.channels.map(item => item.channel_id);
          },

          unbindChannel(channel_id) {
              this.$confirm("确认要解绑该渠道？", "温馨提示", {type: "warning"}).then(_ => {
                  this.form.channels = this.form.channels.filter(item => item.channel_id !== channel_id);
                  this.form.channel_ids = this.form.channels.map(item => item.channel_id);
              }).catch(err => {
                  console.error(err);
                  return;
              });
          },

          handleLock(item) {
              const targetChannel = this.form.channels.find(channel => channel.channel_id === item.channel_id);
              if (targetChannel) {
                  this.$set(targetChannel, 'is_lock', !targetChannel.is_lock);
              } else {
                  this.$message.error("未找到指定id的绑定区域!");
              }
          },

          handleDelete(row) {
              this.$confirm("确认要删除用户组吗？", "温馨提示", {type: "warning"}).then(_ => {
                SourceGroupService.delete(row.id).then(res => {
                      if (res && res.code == 0) {
                          this.$message({
                              message: "删除成功!",
                              type: "success",
                          });
                          this.resetForm();
                      }else{
                          this.$message({
                              message: res.msg,
                              type: "error",
                          });
                      }
                  }).catch(err => {
                      console.error(err);
                  })
              }).catch(err => {
                  console.error(err);
                  return;
              });
          },
          handleSave() {
              if (!this.form.channels || this.form.channels.length === 0) {
                  this.$message({
                      message: "请选择绑定区域!",
                      type: "error",
                  });
                  return false;
              }
              this.$refs.form.validate((valid) => {
                  if (valid) {
                      this.submiting = true;
                      let source_group_service;
                      if(this.form.id > 0){
                        source_group_service = SourceGroupService.update(this.form);
                      }else{
                        source_group_service = SourceGroupService.create(this.form);
                      }
                      source_group_service.then(res => {
                          if (res && res.code == 0) {
                              this.$message({
                                  message: "保存成功!",
                                  type: "success",
                              });
                              this.resetForm();
                          }
                          this.submiting = false;
                      }).catch(err => {
                          this.submiting = false;
                          console.error(err);
                      })
                  } else {
                      console.log('error submit!!');
                  }
              });
          },
      }
  }
</script>




// WEBPACK FOOTER //
// src/views/user/sourceGroup.vue